<template>
  <van-calendar
    ref="calendar"
    v-model="show"
    :type="type"
    @confirm="onConfirm"
    :default-date="defaultDate"
    :formatter="formatter"
    :show-confirm="false"
    :color="color"
    :get-container="getContainer"
    :allow-same-day="allowSameDay"
  />
</template>
<script>
import { Calendar } from 'vant'
import { formatDate } from 'Utils/dateUtil'
import { mapGetters } from 'vuex'

export default {
  name: 'LdCalendar',
  components: {
    [Calendar.name]: Calendar
  },
  props: {
    type: {
      type: String,
      default: 'single'
    },
    startText: {
      type: String,
      default: '入住'
    },
    endText: {
      type: String,
      default: '离店'
    },
    element: {
      type: String,
      default: ''
    },
    allowSameDay: Boolean
  },
  data () {
    return {
      show: false,
      defaultDate: null,
      color: '',
    }
  },
  computed: {
    ...mapGetters(['loginConfig'])
  },
  mounted () {
    if (this.loginConfig) {
      if (this.loginConfig.themeBean) {
        if (this.loginConfig.themeBean.mainColor) this.color = this.loginConfig.themeBean.mainColor
      }
    }
  },
  methods: {
    // formatDate(date) {
    // 	return `${date.getMonth() + 1}/${date.getDate()}`
    // },
    formatter (day) {
      const month = day.date.getMonth() + 1
      const date = day.date.getDate()
      const today = formatDate(new Date())
      const tomorrow = formatDate(new Date(), 1)

      if (today.month == month) {
        if (today.d == date) {
          day.topInfo = '今天'
        }
      }
      if (tomorrow.month == month) {
        if (tomorrow.d == date) {
          day.topInfo = '明天'
        }
      }

      if (month === 1) {
        if (date === 1) {
          day.topInfo = '元旦'
        } else if (date === 21) {
          day.topInfo = '除夕'
        } else if (date === 22) {
          day.topInfo = '春节'
        }
      }

      if (month === 2) {
        if (date === 5) {
          day.topInfo = '元宵节'
        }
      }
      if (month === 4) {
        if (date === 5) {
          day.topInfo = '清明'
        }
      }
      if (month === 5) {
        if (date === 1) {
          day.topInfo = '劳动节'
        } else if (date === 4) {
          day.topInfo = '青年节'
        }
      }
      if (month === 6) {
        if (date === 22) {
          day.topInfo = '端午节'
        }
      }
      if (month === 7) {
        if (date === 1) {
          day.topInfo = '建党节'
        }
      }
      if (month === 8) {
        if (date === 1) {
          day.topInfo = '建军节'
        }
      }
      if (month === 9) {
        if (date === 29) {
          day.topInfo = '中秋节'
        }
      }
      if (month === 10) {
        if (date === 1) {
          day.topInfo = '国庆节'
        }
      }


      if (day.type === 'start') {
        day.bottomInfo = this.startText
      } else if (day.type === 'end') {
        day.bottomInfo = this.endText
      }

      return day
    },
    onConfirm (date) {
      this.show = false
      let resault = ''
      if (Array.isArray(date)) {
        resault = [formatDate(date[0]).date, formatDate(date[1]).date]
      } else {
        resault = formatDate(date).date
      }
      this.$emit('selected', resault)
    },
    toggle (props) {
      this.show = !this.show
      if (props) {
        if (props.defaultDate) {//默认选中日期
          if (Array.isArray(props.defaultDate)) {//多日期
            let arr = []
            props.defaultDate.forEach(item => {
              arr.push(formatDate(item).datetime)
            })
            this.defaultDate = arr
            this.$refs.calendar.scrollToDate(arr[0])//滚动到 选中日期
          } else {//单日期
            this.defaultDate = formatDate(props.defaultDate).datetime
            this.$refs.calendar.scrollToDate(this.defaultDate)
          }
        }
        //判断 是否有日期单位限制
        if (props.minDate) {
          this.$refs.calendar.minDate = formatDate(props.minDate).datetime
        }
        if (props.maxDate) {
          this.$refs.calendar.maxDate = formatDate(props.maxDate).datetime
        }
      }
    },
    // 返回一个特定的 DOM 节点，作为挂载的父节点
    getContainer () {
      if (this.element) {
        return document.querySelector(this.element)
      }
      return ''
    },
  }
}
</script>
<style scoped>

</style>
